export const getEntityFields = (entityType) => {
  const sharedFields = [
    {
      name: "contactNo",
      label: "Contact No",
      type: "number",
      required: true,
      pattern: /^\d{10}$/,
      errorMessage: "10-digit contact number required",
    },
    { name: "email", label: "Email", type: "email" },
    { name: "firmName", label: "Firm Name", type: "text" },
    { name: "officeAddress", label: "Office Address", type: "text" },
  ];

  switch (entityType) {
    case "owner":
      return [
        {
          name: "name",
          label: "Owner Name",
          type: "text",
          required: true,
          errorMessage: "Owner name is required",
        },
        ...sharedFields,
      ];
    case "architect":
      return [
        {
          name: "name",
          label: "Architect Name",
          type: "text",
          required: true,
          errorMessage: "Architect name is required",
        },
        ...sharedFields,
      ];
    case "fabricator":
      return [
        {
          name: "name",
          label: "Fabricator Name",
          type: "text",
          required: true,
          errorMessage: "Fabricator name is required",
        },
        ...sharedFields,
      ];
    default:
      return [];
  }
};

export const getSaveUrl = (entityType) => {
  switch (entityType) {
    case "owner":
      return "Owner/SaveUpdate";
    case "architect":
      return "Architect/SaveUpdate";
    case "fabricator":
      return "Fabricator/SaveUpdate";
    default:
      return "";
  }
};
